import { runInAction, makeAutoObservable } from 'mobx';

class Navigation {
  lang = 'rs';
  translations = {};

  constructor() {
    makeAutoObservable(this);
  }

  setLang = (lang) => {
    this.lang = lang;
  }

  setTranslations = (translations) => {
    this.translations = translations;
  }
}

export default Navigation;
